<template>
  <base-modal height="600"
              :show="show"
              @close="close">
    <div slot="header">
      {{ $t("websiteSettings.title") }}
    </div>

    <website-settings :mode-id="fromBus.modeId"
                      :child-id="fromBus.childId" />
  </base-modal>
</template>

<script>
  import WebsiteSettings from '@/components/Child/ChildWebsiteSettings/WebsiteSettings'
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      WebsiteSettings
    },

    data() {
      return {
        fromBus: {
          modeId: '',
          childId: ''
        }
      }
    },

    beforeMount() {
      this.setOpenListener('websettings')
    }
  }
</script>
